module.exports = __webpack_public_path__ + "static/assets/da3b99d66e46d9e0a917b5ff7d0d90be.png";